export default {"src":"/_next/static/media/bk_small_black.cb84c88d.svg","height":74,"width":73,"blurWidth":0,"blurHeight":0};